import { useTheme } from '@/theme';
import { Toaster } from 'sonner';

/**
 * Global toast host for the web app.
 * Keep all Sonner setup centralized so feature components only use our wrapper API.
 */
export function ToastProvider(): JSX.Element {
  const { colorScheme } = useTheme();

  return (
    <Toaster
      richColors
      closeButton
      expand={false}
      position="top-right"
      offset={{ top: 80, right: 16 }}
      theme={colorScheme}
      toastOptions={{
        duration: 4000,
      }}
    />
  );
}
